import { useParams } from "react-router-dom";
import { WeddingInfo } from "../WeddingInfo/WeddingInfo";
import NetflixHeartList from "./NetflixHeartList";
import NetflixLocation from "./NetflixLocation";
import NetflixPreview from "./NetflixPreview";
import NetflixRepresentScreen from "./NetflixRepresent";
import NetflixTop10Series from "./NetflixTop10Series";
import { useState, useEffect } from "react";
import NetflixAccountList from "./NetflixAccountList";
import useBackgroundMusic from "../Common/useBackgroundMusic";
import { FaVolumeXmark, FaVolumeHigh } from "react-icons/fa6";
import WeddingCalendar from "../Common/WeddingCalendar";
import NetflixImageModal from "./NetflixImageModal";

const SplashScreen = () => {
  useEffect(() => {
    const audio = new Audio(
      `${process.env.PUBLIC_URL}/NetflixIntro.mp3`
    );

    audio.volume = 0.7;
    audio.play().catch(() => {
      // 모바일 autoplay 제한 대비
      console.log("Autoplay prevented");
    });

    return () => {
      audio.pause();
      audio.currentTime = 0;
    };
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black">
      <img
        src={`${process.env.PUBLIC_URL}/netflix-logo.webp`}
        alt="Metflix Logo"
        className="w-40 h-auto"
      />
      <img
        src={`${process.env.PUBLIC_URL}/metflix.png`}
        alt="Metflix Logo"
        className="w-40 h-auto"
      />
    </div>
  );
};

const NetflixScreen = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const info = WeddingInfo.getInfo(id);
  const bgmSongName =
    window.location.hostname == "xn--vj5bwo95cw9x.com"
      ? "everything.mp3"
      : "wedding-sample-music.mp3";
  const { isMuted, toggleMute } = useBackgroundMusic(
    `${process.env.PUBLIC_URL}/` + `${info.common.netflixBGM ?? bgmSongName}`
  );

  const [modal, setModal] = useState<{
    open: boolean;
    src?: string;
    title?: string;
  }>({
    open: false,
  });

  const handleOpenImage = (src: string, title?: string) => {
    setModal({ open: true, src, title });
  };
  const handleCloseImage = () =>
    setModal({ open: false, src: undefined, title: undefined });

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <SplashScreen />;
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black">
      <meta name="theme-color" content="#000000" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="#000000" />
      <div className="w-full max-w-md bg-black text-center mb-12 mx-4">
        <div className="w-full max-w-md bg-white p-0 text-center mb-12 relative">
          {/* 🔊 뮤트 버튼 */}
          <button
            onClick={toggleMute}
            className="absolute top-4 right-4 z-50 bg-white bg-opacity-80 hover:bg-opacity-100 transition p-2 rounded-full"
          >
            {isMuted ? (
              <FaVolumeXmark className="text-black w-5 h-5" />
            ) : (
              <FaVolumeHigh className="text-black w-5 h-5" />
            )}
          </button>

          {/* 메인 콘텐츠 내용들 */}
        </div>
        <div className="relative w-30 h-10 flex space-x-2 ml-4 mt-4">
          <img
            src={`${process.env.PUBLIC_URL}/metflix.png`}
            alt="Music Icon"
            className=""
          />
        </div>
        <div className="flex items-center space-x-2 mt-4 mb-6 mx-4">
          <div className="text-white font-medium text-md">
            {info.common.groomName} ❤️ {info.common.brideName}
          </div>
        </div>
        <NetflixRepresentScreen poster={info.netflix.posterInfo} />
        <NetflixTop10Series
          top10={info.netflix.top10Info}
          onOpenImage={handleOpenImage}
        />
        <NetflixPreview newHot={info.netflix.newHotInfo} />
        <NetflixHeartList
          heart={info.netflix.heartInfo}
          onOpenImage={handleOpenImage}
        />
        <NetflixLocation
          location={info.common.addressInfo}
          weddingDate={info.common.weddingDateKR}
        />
        <WeddingCalendar
          weddingDateKR={info.common.weddingDateKR}
          weddingDate={info.common.weddingDate}
          backgroundColor="bg-netflix"
          textColor="text-netflix"
        />

        <NetflixAccountList accountInfos={info.netflix.accountInfo} />
      </div>

      <NetflixImageModal
        isOpen={modal.open}
        src={modal.src}
        title={modal.title}
        onClose={handleCloseImage}
      />
    </div>
  );
};

export default NetflixScreen;
